(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/tipsinfo.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/tipsinfo.js'); svs.tipset.views.Tipsinfo = Backbone.Marionette.View.extend({
  className: 'centered modal-bottom-padding',
  tagName: 'div',
  events: {
    'click .js-btn-hideall': 'onHideallClick',
    'click .js-tipsinfo': 'onTipsInfoClicked'
  },

  modelEvents: {
    'change allStatsUpdated': 'render'
  },

  template: function(data) {
    return svs.tipset.templates.tipsinfo(data);
  },

  initialize: function() {
    this.uid = svs.tipset.getUid();
    this.hideStatistics =
      svs.tipset.models.gameDefinitions.get('hideStatistics') || false;
    if (!svs.tipset.models.statistics) {
      svs.tipset.models.statistics = new svs.tipset.models.Statistics();
    }

    this.model.fetchGameAnalyzes();
  },

  onHideallClick: function() {
    this.model.toggleHideAll();
  },

  onTipsInfoClicked: function(e) {
    this.model.toggleStats($(e.currentTarget).data('btnid'));
  },

  onClose: function() {
    svs.tipset.models.statistics.trigger(
      'change',
      svs.tipset.models.statistics
    );
    svs.tipset.models.statistics.save();
    this.undelegateEvents();
    this.stopListening();
  }
});

 })(window);